import React from "react";

function Home() {
  return (
    <div>
      <h1>Welcome to Monster Deluge!</h1>
      <p>Catch, collect, and battle monsters in this RPG adventure.</p>
    </div>
  );
}

export default Home;
